import { BaseApiService } from '@/shared/api/services/base.service';

interface UpdateLocaleResponse {
  data: {
    type: string;
    id: string;
    attributes: {
      name: string;
      email: string;
      locale: string;
      is_watermark_enabled: boolean;
      is_email_verified: boolean;
      email_verified_at: string | null;
      created_at: string;
      updated_at: string;
    };
  };
}

class LocaleService extends BaseApiService {
  async updateLocale(locale: string): Promise<UpdateLocaleResponse> {
    return this.put<UpdateLocaleResponse>(
      '/v1/user/locale',
      this.formatJsonApiData('user', { locale })
    );
  }
}

export const localeService = new LocaleService();
